var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Promise from 'bluebird';
import Helper from '../riHelper';
import { CacheLayer, getViewFieldsXml } from '@/central';
import { BaseService } from './BaseService';
import { every } from '@/central';
import { TaxonomyHelper } from './TaxonomyHelper';
var EventService = (function (_super) {
    __extends(EventService, _super);
    function EventService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(EventService.prototype, "viewFields", {
        get: function () {
            return [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventService.prototype, "fieldTitle", {
        get: function () {
            return 'Title';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventService.prototype, "fieldTeaser", {
        get: function () {
            return 'anrisstext';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventService.prototype, "fieldDate", {
        get: function () {
            return 'Created';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventService.prototype, "fieldEditDate", {
        get: function () {
            return 'Modified';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventService.prototype, "fieldCategory", {
        get: function () {
            return 'RUBKategorien';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventService.prototype, "urlWeb", {
        get: function () {
            return 'termine';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventService.prototype, "urlList", {
        get: function () {
            return 'Lists/Veranstaltungen';
        },
        enumerable: true,
        configurable: true
    });
    EventService.prototype.finalizeItem = function (item, spItem, categoryField, list, web, site) {
        item.isNew = new Date(item.date) > new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 5);
        var category = TaxonomyHelper.getTermFieldValues(spItem.get_item(this.fieldCategory));
        if (category.length > 0) {
            item.category = category[0].get_label();
        }
        item.date = undefined;
        item.dates = [];
        item.url = web.get_serverRelativeUrl().replace(/\/+$/, '') + "/seiten/veranstaltung.aspx?vid=" + item.id;
        return Promise.resolve(item);
    };
    EventService.prototype.finalizeItems = function (items, list, web, site) {
        var ctx = web.get_context();
        var detailsList = web.getList(web.get_serverRelativeUrl().replace(/\/+$/, '') + "/" + EventService.urlListDetails);
        var viewFields = [EventService.fieldDateStart, EventService.fieldVID];
        var fields = getViewFieldsXml(viewFields);
        var query = new SP.CamlQuery();
        query.set_viewXml("<View>" + fields +
            "<Query>" +
            "<Where>" +
            ("<Geq><FieldRef Name=\"" + EventService.fieldDateStart + "\" /><Value Type=\"DateTime\" IncludeTimeValue=\"True\" StorageTZ=\"True\">" + new Date().toISOString() + "</Value></Geq>") +
            "</Where>" +
            ("<OrderBy><FieldRef Name=\"" + EventService.fieldDateStart + "\" Ascending=\"TRUE\"/></OrderBy>") +
            "</Query>" +
            "</View>");
        var spItems = detailsList.getItems(query);
        ctx.load(spItems);
        return new Promise(function (resolve, reject) {
            return Helper.clientContextExecute(ctx)
                .then(function () {
                var datesById = {};
                every(spItems, function (spItem, i) {
                    var date = new Date(spItem.get_item(EventService.fieldDateStart));
                    var id = spItem.get_item(EventService.fieldVID);
                    var dates = datesById[id] || [];
                    dates.push(date);
                    datesById[id] = dates;
                });
                resolve(items.map(function (i) {
                    var dates = datesById[i.id];
                    if (dates && dates.length > 0) {
                        i.date = dates[0].toISOString();
                        i.dates = dates.map(function (d) { return d.toISOString(); });
                    }
                    return i;
                }));
            })
                .catch(reject);
        });
    };
    EventService.prototype.loadSubItems = function (category, sort, rowLimit) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            TaxonomyHelper.getChildrenWssIdsByTermItem(category).then(function (subCategoryIds) {
                if (subCategoryIds.length === 0) {
                    resolve([]);
                    return;
                }
                var orderBy = _this.getOrderByCaml(sort);
                return _this.loadItemsByQuery("<Query>" +
                    "<Where>" +
                    "<And>" +
                    ("<In><FieldRef LookupId='True' Name='" + _this.fieldCategory + "'/><Values>" + subCategoryIds.map(function (id) { return "<Value Type='Integer'>" + id + "</Value>"; }) + "</Values></In>") +
                    ("<Eq><FieldRef Name='" + EventService.fieldStatus + "'/><Value Type='Text'>freigegeben</Value></Eq>") +
                    "</And>" +
                    "</Where>" +
                    ("<OrderBy>" + orderBy.caml + "</OrderBy>") +
                    "</Query>" +
                    ("<RowLimit>" + rowLimit + "</RowLimit>")).then(function (items) {
                    items = _this.postOrderItems(sort, items);
                    resolve(items);
                });
            });
        });
    };
    EventService.prototype.loadEvents = function (category, sort, rowLimit) {
        var _this = this;
        if (rowLimit === void 0) { rowLimit = 100; }
        return CacheLayer.simpleLoad(function () {
            return _this.loadSubItems(category, sort, rowLimit);
        }, "loadEvents-" + category.id + "-" + sort + "-" + rowLimit);
    };
    EventService.prototype.loadAllItems = function (sort, rowLimit) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var orderBy = _this.getOrderByCaml(sort);
            _this.loadItemsByQuery("<Query>" +
                "<Where>" +
                ("<Eq><FieldRef Name='" + EventService.fieldStatus + "'/><Value Type='Text'>freigegeben</Value></Eq>") +
                "</Where>" +
                ("<OrderBy>" + orderBy.caml + "</OrderBy>") +
                "</Query>" +
                ("<RowLimit>" + rowLimit + "</RowLimit>"))
                .then(function (items) {
                items = _this.postOrderItems(sort, items);
                resolve(items);
            });
        });
    };
    EventService.prototype.postOrderItems = function (sort, items) {
        var orderBy = this.getOrderByCaml(sort);
        if (orderBy.special === 'emptylast') {
            var sortField_1 = orderBy.field;
            var sortAscending_1 = orderBy.asc;
            if (sortField_1) {
                items.sort(function (item1, item2) {
                    if (item1[sortField_1] === item2[sortField_1]) {
                        return 0;
                    }
                    else if (item1[sortField_1] !== undefined && item2[sortField_1] === undefined) {
                        return -1;
                    }
                    else if (item1[sortField_1] === undefined && item2[sortField_1] !== undefined) {
                        return 1;
                    }
                    else {
                        if (sortAscending_1) {
                            return item1[sortField_1].localeCompare(item2[sortField_1]);
                        }
                        else {
                            return item1[sortField_1].localeCompare(item2[sortField_1]) * -1;
                        }
                    }
                });
            }
        }
        return items;
    };
    EventService.prototype.loadAllEvents = function (sort, rowLimit) {
        var _this = this;
        if (rowLimit === void 0) { rowLimit = 100; }
        return CacheLayer.simpleLoad(function () {
            return _this.loadAllItems(sort, rowLimit);
        }, "loadAllEvents-" + sort + "-" + rowLimit);
    };
    EventService.urlListDetails = 'Lists/Veranstaltungstermine';
    EventService.fieldVID = 'vID';
    EventService.fieldDateStart = 'terminbeginn';
    EventService.fieldStatus = 'vstatus';
    return EventService;
}(BaseService));
export { EventService };
